import { mobileQrLoginMount } from './mobile-qr-login-mount';

export { MobileQrLoginModal } from './mobile-qr-login-modal.react';

document.querySelector('.js-show-mobile-qr-modal')?.addEventListener('click', () => {
	mobileQrLoginMount();
});
